"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _MultipleAssociationsSelectContent = _interopRequireDefault(require("./MultipleAssociationsSelectContent"));

function MultipleAssociationsSelect(props) {
  var _React$useState = _react.default.useState(''),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      searchText = _React$useState2[0],
      setSearchText = _React$useState2[1];

  var _React$useState3 = _react.default.useState(''),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      debouncedSearchTextForElasticSearch = _React$useState4[0],
      setDebouncedSearchTextForElasticSearch = _React$useState4[1];

  return _react.default.createElement(_MultipleAssociationsSelectContent.default, (0, _extends2.default)({}, props, {
    searchText: searchText,
    setSearchText: setSearchText,
    debouncedSearchTextForElasticSearch: debouncedSearchTextForElasticSearch,
    setDebouncedSearchTextForElasticSearch: setDebouncedSearchTextForElasticSearch
  }));
}

MultipleAssociationsSelect.propTypes = _MultipleAssociationsSelectContent.default.componentPropTypes;
MultipleAssociationsSelect.defaultProps = _MultipleAssociationsSelectContent.default.defaultProps;
var _default = MultipleAssociationsSelect;
exports.default = _default;
module.exports = exports.default;